import * as React from 'react';;
import { Organization } from '../../models/organization';

interface OrganizationListProps {
    organizations: Organization[];
    editingOrganization: Partial<Organization> | null;
    setEditingOrganization: (organization: Organization) => void;
    updateOrganization: (organizationId: string) => void;
    deleteOrganization: (organizationId: string) => void;
}

const OrganizationList: React.FC<OrganizationListProps> = ({
    organizations,
    setEditingOrganization,
    deleteOrganization
}) => {
    if (!organizations || organizations.length === 0) {
        return <div className="section">No organizations found</div>;
    }
    
    return (
        <div className="section">
            <ul className="list">
                {organizations.map(org => (
                    <li key={org.organizationId} className="list-item">
                        <div className="info">
                            <span className="name">{org.organizationName || 'Unnamed'}</span>
                            <span className="name">{org.mascotName || '-'}</span>
                            <span className="funds">
                                ${(org.pointsAvailable !== undefined && org.pointsAvailable !== null) 
                                    ? org.pointsAvailable.toLocaleString() 
                                    : '0'}
                            </span>
                            <div className="actions">
                                <button onClick={() => setEditingOrganization(org)} className="edit-button">Edit</button>
                                <button onClick={() => deleteOrganization(org.organizationId)} className="delete-button">Delete</button>
                            </div>
                        </div>
                    </li>
                ))}
            </ul>
        </div>
    );
};

export default OrganizationList;
